<template>
  <main class="container text-center">
    <h1 class="mb-4">Demo</h1>
    <div class="flex-col text-big">
      <a href="/scratchpad">Scratchpad</a>
      <a href="/journal">Journal</a>
    </div>
  </main>
</template>

<script setup lang="ts"></script>
<style scoped lang="less">
.flex-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
}

.mb-4 {
  margin-bottom: 4rem;
}
</style>
